import React from "react";

export function LogoMark({ size = 32, className = "" }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 64 64"
      className={className}
      aria-hidden="true"
      focusable="false"
    >
      <polygon points="32,2 57.98,17 57.98,47 32,62 6.02,47 6.02,17" fill="#0A192F" />
      <rect x="17" y="34" width="7" height="12" rx="1.2" fill="#F8FAFC" />
      <rect x="28.5" y="28" width="7" height="18" rx="1.2" fill="#F8FAFC" />
      <rect x="40" y="22" width="7" height="24" rx="1.2" fill="#C85A32" />
    </svg>
  );
}

export function Logo({ size = 34, light = false }) {
  return (
    <span className="flex items-center gap-2.5">
      <LogoMark size={size} />
      <span
        className={`text-[1.35rem] font-extrabold tracking-tight font-heading ${
          light ? "text-white" : "text-ink"
        }`}
      >
        Litio<span className="text-terracotta">data</span>
      </span>
    </span>
  );
}
